import React, { Fragment, useState, useEffect } from "react";
import CancelPresentationRoundedIcon from "@mui/icons-material/CancelPresentationRounded";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import styled from "styled-components";
import { Select, MenuItem } from "@mui/material";
import { CurrencyState } from "../Context";
import axios from "axios";

//Flags
import SouthAfrica from "../assets/south-africa.png";
import America from "../assets/america.png";
import Nigeria from "../assets/nigeria.png";
import Kenya from "../assets/kenya.png";

const Header = () => {
  const { id, currency, setCurrency, country, city } = CurrencyState();

  const [colorChange, setColorchange] = useState(false);
  const changeNavbarColor = () => {
    if (window.scrollY >= 10) {
      setColorchange(true);
    } else {
      setColorchange(false);
    }
  };
  window.addEventListener("scroll", changeNavbarColor);
  const [BurgerStatus, setBurgerStatus] = useState(false);

  const [data, setData] = useState(null);
  const url = `https://api.coingecko.com/api/v3/coins/markets?vs_currency=${currency}&order=market_cap_desc&per_page=25&page=1&sparkline=false`;

  useEffect(() => {
    axios
      .get(url)
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [currency]);

  if (!data) return null;

  return (
    <Fragment>
      <NavContainer className={colorChange ? "navbar colorChange" : "navbar"}>
        <Link to={`/`} onClick={() => setBurgerStatus(false)} title="">
          <h1>
            Le<span className="primary">hu</span>mo
          </h1>
        </Link>

        <Menu>
          {/* 
          <Link
            to="/AssetPage/bitcoin"
            onClick={() => setBurgerStatus(false)}
            title=""
          >
            <i className="fa-brands fa-bitcoin"></i>{" "}
            {data[0].current_price.toLocaleString()}
          </Link>

          */}

          <Link
            to={`/Portfolio`}
            onClick={() => setBurgerStatus(false)}
            title=""
          >
            Portfolio
          </Link>

          <Link
            to="/CryptocurrenciesList"
            onClick={() => setBurgerStatus(false)}
            title=""
          >
            Markets
          </Link>

          <Link to="/Merch" onClick={() => setBurgerStatus(false)} title="">
            Goodies
          </Link>
        </Menu>

        <RightMenu>
          <RightMenuItems>
            <Link to={`/Profile`}>
              <button className="account-btn">Profile</button>
            </Link>
            <Select
              variant="outlined"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={currency}
              style={{
                width: 110,
                height: 50,
                marginRight: 15,
                border: 0,
                fontSize: 13,
                fontWeight: "bold",
              }}
              onChange={(e) => setCurrency(e.target.value)}
            >
              <MenuItem value={"USD"}>
                <Flag>
                  USD
                  <img src={America} alt="" />
                </Flag>
              </MenuItem>
              <MenuItem value={"ZAR"}>
                <Flag>
                  ZAR
                  <img src={SouthAfrica} alt="" />
                </Flag>
              </MenuItem>
              {/* 
                <MenuItem value={"NGN"}><Flag>NGN<img src={Nigeria} alt="" /></Flag></MenuItem>
                <MenuItem value={"KES"}><Flag>KES<img src={Kenya} alt="" /></Flag></MenuItem>
              */}
            </Select>
          </RightMenuItems>

          <CustomMenu onClick={() => setBurgerStatus(true)} />
        </RightMenu>
        <BurgerNav show={BurgerStatus}>
          <CloseButtonWrap>
            <CloseButton onClick={() => setBurgerStatus(false)} />
          </CloseButtonWrap>

          <ul>
            <li onClick={() => setBurgerStatus(false)}>
              <Link to={`/`} title="">
                {" "}
                <i className="fa-solid fa-house"></i> Home
              </Link>
            </li>

            <li onClick={() => setBurgerStatus(false)}>
              <Link to="/Signup" title="">
                <i className="fa-solid fa-user-plus"></i> Sign up
              </Link>
              <button>New Account</button>
            </li>

            <li onClick={() => setBurgerStatus(false)}>
              <Link to="/Login" title="">
                <i className="fa-solid fa-arrow-right-to-bracket"></i> Sign in
              </Link>
            </li>

            <li onClick={() => setBurgerStatus(false)}>
              <Link to={`/Profile`} title="">
                <i className="fa-regular fa-user"></i> Profile
              </Link>
            </li>

            <li onClick={() => setBurgerStatus(false)}>
              <Link to={`/Portfolio`} title="">
                <i className="fa-solid fa-wallet"></i> Portfolio
              </Link>
            </li>

            <li onClick={() => setBurgerStatus(false)}>
              <Link to="/CryptocurrenciesList" title="">
                <i className="fa-solid fa-chart-simple"></i> Markets
              </Link>
              <button>Assets</button>
            </li>

            <li onClick={() => setBurgerStatus(false)}>
              <Link to="/News" title="">
                <i className="fa-solid fa-newspaper"></i> News
              </Link>
              <button>Updates</button>
            </li>

            <li onClick={() => setBurgerStatus(false)}>
              <Link to="/" title="">
                <i className="fa-sharp fa-solid fa-briefcase"></i> Company
              </Link>
            </li>

            <li onClick={() => setBurgerStatus(false)}>
              <Link to="Contact" title="">
                <i className="fa-solid fa-circle-question"></i> Help Centre
              </Link>
            </li>

            <li onClick={() => setBurgerStatus(false)}>
              <Link to="/" title="">
                <i className="fa-solid fa-users"></i> Careers
              </Link>
            </li>

            <li onClick={() => setBurgerStatus(false)}>
              <Link to="/Merch" title="">
                <i className="fa-solid fa-shop"></i> Buy Merch
              </Link>
            </li>

            <li onClick={() => setBurgerStatus(false)}>
              <i className="fa-sharp fa-solid fa-location-dot"></i> {country},{" "}
              {city}
            </li>
          </ul>
        </BurgerNav>
      </NavContainer>
    </Fragment>
  );
};

export default Header;

const NavContainer = styled.div`
  min-height: 70px;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  top: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  z-index: 4;
  width: 1;
  overflow: hidden;
  border-bottom: 1px solid #eee;

  img {
    width: 55px;
    height: 40px;
    cursor: pointer;
    margin-top: 7px;
  }

  :hover {
    background-color: #ffffff;
    transition: 0.3s ease-in;
  }
`;

const Menu = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;

  a {
    font-weight: 700;
    text-transform: uppercase;
    padding: 0 30px;
    flex-wrap: no-wrap;
    color: #333;
    font-size: 14px;
    font-family: "Poppins", sans-serif;

    :hover {
      color: var(--primary);
    }
  }

  @media (max-width: 854px) {
    display: none;
  }
`;

const RightMenu = styled.div`
  display: flex;
  align-items: center;

  a {
    font-weight: 600;
    margin-right: 10px;
    color: #333;

    :hover {
      color: #b0a9aa;
    }
  }
`;

const RightMenuItems = styled.div`
  select {
    width: 120px;
    height: 50px;
    margin-right: 10px;
    border: none;
    outline: none;
    font-weight: bold;
  }

  img {
    width: 25px;
    height: 15px;
    margin-left: 10px;
  }

  @media (max-width: 990px) {
    .account-btn {
      display: none;
    }

    select {
      height: 45px;
      width: 50px;
    }
  }
`;

const CustomMenu = styled(MenuIcon)`
  color: #333;
  cursor: pointer;

  :hover {
    color: #b0a9aa;
  }
`;

const BurgerNav = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: #ffffff;
  width: 25%;
  z-index: 10;
  list-style: none;
  padding: 20px;
  display: flex;
  flex-direction: column;
  text-align: start;
  transform: ${(props) => (props.show ? "translateX(0)" : "translateX(100%)")};
  transition: 0.3s ease-in;

  ul {
    list-style: none;
  }

  li {
    padding: 15px 0;
    border-bottom: 1px solid #fff;
    color: #333;
    font-weight: 600;
    font-family: "Poppins", sans-serif;
    font-size: 14px;

    a {
      color: #333;
      font-family: "Poppins", sans-serif;
      font-size: 14px;

      :hover {
        color: var(--primary);
        transition: all ease 0.3s;
      }
    }

    button {
      width: 70px;
      height: 20px;
      font-size: 8px;
      font-weight: bold;
      margin-left: 10px;
      border: none;
      color: #fff;
      background-color: var(--primary);
      border-radius: 5px;
    }
  }

  @media (max-width: 820px) {
    width: 100%;
  }
`;

const CloseButtonWrap = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const CloseButton = styled(CancelPresentationRoundedIcon)`
  cursor: pointer;
  color: #333;

  :hover {
    color: #b0a9aa;
  }
`;

const Flag = styled.div`
  font-weight: bold;

  img {
    width: 25px;
    height: 15px;
    margin-left: 10px;
  }
`;
